import apiClient from '../apiClient';
import { UPLOAD_COMMIT_RESTAURANT_ITEM_URL } from '../apiUrl';

const uploadMasterRestaurantItemApi = data => {
  return apiClient.post(UPLOAD_COMMIT_RESTAURANT_ITEM_URL, data);
};

export default uploadMasterRestaurantItemApi;
